import React from 'react'
import Footer from '../Footer'
import ImageInkTwo from '../ImageInkTwo'

function ImgInkTwo() {
    window.scrollTo(0,0);
    return (
        <>
            <ImageInkTwo/>
            <Footer/>
        </>
    )
}

export default ImgInkTwo
